// TODO: Remove this file once refactored to use common/SummaryTable
import { useState } from 'react';
import {
  Typography,
  Card,
  IconButton,
  Stack,
  TableContainer,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
  MenuItem,
  Menu,
  Box,
} from '@mui/material';
import Iconify from 'src/components/Iconify';

const SummaryTable = ({ actionBar, data, noContextMenu }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const openMenu = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  return (
    <Card sx={{ height: `calc(100vh - 200px)`, display: 'flex', flexDirection: 'column' }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
        <Typography variant="subtitle1">{data.title}</Typography>
        <Box>{actionBar}</Box>
      </Stack>
      <TableContainer sx={{ maxHeight: '100%' }}>
        <Table stickyHeader>
          {data.columns && (
            <TableHead>
              <TableRow>
                {data.columns.map((col: any, index: number) => (
                  <TableCell key={`col-${index}`}>{col.label}</TableCell>
                ))}
                <TableCell>&nbsp;</TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {data?.rows?.map((row: any, index: number) => (
              <TableRow key={`row-${index}`}>
                {row.values.map((value: any, index: number) => (
                  <TableCell key={`value-${index}`}>
                    <Typography variant="body2">{value}</Typography>
                  </TableCell>
                ))}
                {noContextMenu === true ? null : (
                  <TableCell align="right">
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={closeMenu}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem>
                        <Stack direction="row" spacing={2}>
                          <Iconify icon="eva:edit-fill" />
                          <Typography variant="body2">Edit</Typography>
                        </Stack>
                      </MenuItem>
                      <MenuItem>
                        <Stack direction="row" spacing={2}>
                          <Iconify icon="eva:copy-fill" />
                          <Typography variant="body2">Clone</Typography>
                        </Stack>
                      </MenuItem>
                    </Menu>
                    <IconButton onClick={openMenu}>
                      <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default SummaryTable;
